<template>
    <div class="qywh">
        <div class="banner">
            <img class=" banner_img" src="../../static/img/qywh_banner.png" alt="">
        </div>
        <div class="content">
            <div class="title_wrap">
                <p class="news_title">最新新闻 </p>
            </div>
            <div class="news w1200">
                <ul class="news_text">
                    <li v-for="(item,i) in news " :key="i">
                        <div class="left">
                            <span>{{item.day}}</span>
                            <span class="hx"></span>
                            <span>{{item.month}}</span>
                            <span>{{item.year}}</span>
                        </div>
                        <div class="right">
                            <h4>{{item.xwnr}}</h4>
                        </div>
                        <div class="ckgd" @click="$router.push({path:item.path })">
                            <p>
                                <span>查看更多</span>
                                <span><img src="../../static/img/baijt.png" alt=""></span>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="title_wrap">
                <p class="news_title">员工风采 </p>
            </div>
            <div class="ygfc w1200">
                <div class="ygfc_img" v-for="(item,i) in ygfc" :key="i">
                    <div class="ygfc_img1">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="fgfc_1">
                        <p>______</p>
                        <h4>{{item.h4_text}}</h4>
                        <p>{{item.p_text}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'qywh',
  data () {
    return {
      news: [
        {
          day: '18',
          month: '12',
          year: '2018',
          xwnr: '热烈庆祝北京飞猪科技获得了“中关村高新技术企业”证书',
          path: '/fzxw?page=4&id=0'
        },
        {
          day: '08',
          month: '11',
          year: '2018',
          xwnr: '北京飞猪科技董事长出席金融峰会并在当地调研',
          path: '/fzxw?page=4&id=1'
        },
        {
          day: '14',
          month: '08',
          year: '2018',
          xwnr: '北京飞猪科技在上海分公司召开第二季度会议',
          path: '/fzxw?page=4&id=2'
        },
        {
          day: '16',
          month: '07',
          year: '2018',
          xwnr: '发展与改革势在必行！',
          path: '/fzxw?page=4&id=3'
        },
        {
          day: '28',
          month: '06',
          year: '2018',
          xwnr: '北京飞猪科技车险保费跨越率在不断增涨，正在奋进行业前列',
          path: '/fzxw?page=4&id=4'
        },
        {
          day: '11',
          month: '06',
          year: '2018',
          xwnr: '离不开交流的技术与运营',
          path: '/fzxw?page=4&id=5'
        },
        {
          day: '20',
          month: '05',
          year: '2018',
          xwnr: '北京飞猪科技技术部门召开关于太平专属APP的会议',
          path: '/fzxw?page=4&id=6'
        }
      ],
      ygfc: [
        {
          img: require('../../static/img/qywh_jkr.png'),
          h4_text: '健康活动日',
          p_text: '每到周三下午，飞猪所以员工都会聚在一起打球运动，放松身心'
        },
        {
          img: require('../../static/img/qywh_glyg.png'),
          h4_text: '鼓励员工大会',
          p_text: '每一季度公司召开全体员工会议，并在大会上给予鼓励与奖励，激发公司员工的工作热情。'
        },
        {
          img: require('../../static/img/qywh_jjgj.png'),
          h4_text: '积极共进 留影合照',
          p_text: '每一年年中会议后，董事长都会与积极奋进的员工们一起合照，记录这一时期的光荣。'
        },
        {
          img: require('../../static/img/qywh_hls.png'),
          h4_text: '欢乐颂年中聚会',
          p_text: '欢乐颂聚会更多的是体现在为新员工迎新，让新员工更快的融入到这个大家庭中，更好的熟悉各位同事。'
        }
      ]
    }
  },
  mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/culture" });
        } else {
          this.$router.push({ path: "/qywh?page=4" });
        }
  },
   methods: {
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
  
}
</script>

<style lang="scss" scoped>
.content {
    max-width: 19.2rem;
    width: 100%;
    margin: 0 auto;
    height: auto;
    background-color: #014fa2;
    .news_title {
        height: 1.1rem;
        line-height: 1.1rem;
        background-color: #de101d;
        text-align: center;
        margin: 0 auto;
        font-size: .36rem;
        color: #feffff;
    }
    .news {
        height: 9.2rem;
        margin-top: .4rem;
        .news_text {
            text-align: center;
            li {
                box-sizing: border-box;
                width: 48%;
                height: 1.8rem;
                background-color: #f2f2f2;
                float: left;
                margin-top: .4rem;
                padding-top: .15rem;
                color: #949494;
                position: relative;
                // float: left;
                .left {
                    width: 1.05rem;
                    height: 1.5rem;
                    float: left;
                    margin-left: .25rem;
                    text-align: center;
                    border-right: 2px solid #cbcbcb;
                    span {
                        float: left;
                        font-size: .22rem;
                        line-height: .4rem;
                        width: 1.05rem;
                    }
                    .hx {
                        margin-left: .3rem;
                        width: .35rem;
                        height: .15rem;
                        line-height: .15rem;
                        border-bottom: 2px solid #cbcbcb;
                    }
                    span:nth-child(1) {
                        font-size: .32rem;
                    }
                }
                .right {
                    width: 3.95rem;
                    float: left;
                    line-height: .4rem;
                    font-size: .3rem;
                    padding-left: .3rem;
                    text-align: left;
                    padding-top: .2rem;
                }
                .ckgd {
                    width: 100%;
                    height: 1.8rem;
                    background-color: #de101d;
                    margin-top: -.2rem;
                    position: absolute;
                    font-size: .2rem;
                    color: #f0fff8;
                    opacity: 0;
                    p {
                        height: .2rem;
                        display: flex;
                        padding-top: .8rem;
                        justify-content: space-between;
                        span {
                            padding: 0 .4rem;
                        }
                    }
                }
            }
            li:nth-child(odd) {
                margin-right: .24rem;
            }
            li:hover {
                background-color: #de101d;
                .ckgd {
                    opacity: 1;
                }
            }
        }
    }
    .ygfc {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: .2rem 0 .4rem 0;
        .ygfc_img {
            display: flex;
            margin-top: .3rem;
            color: #ffffec;
            .fgfc_1 {
                cursor: pointer;
                width: 3.1rem;
                margin: 0 auto;
                padding: .1rem .1rem;
                h4 {
                    font-size: .32rem;
                    line-height: .55rem;
                }
                p {
                    font-size: .22rem;
                    color: #bccfdd;
                    line-height: .38rem;
                }
                p:nth-child(1) {
                    line-height: 2px;
                    padding-bottom: .15rem;
                }
            }
        }
        .ygfc_img:hover {
            opacity: 0.7;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Qywh.vue